import { render, staticRenderFns } from "./AdminPolicySellYG.vue?vue&type=template&id=e7000c9c&scoped=true&"
import script from "./AdminPolicySellYG.vue?vue&type=script&lang=js&"
export * from "./AdminPolicySellYG.vue?vue&type=script&lang=js&"
import style0 from "./AdminPolicySellYG.vue?vue&type=style&index=0&id=e7000c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_@vue+com_158fd1d6ef9e4cc6d0695d4cab9c983b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7000c9c",
  null
  
)

export default component.exports